module.exports = "<div class=\"card-message-alert\" ng-if=\"$ctrl.messageAlert\" ng-class=\"$ctrl.getClasses()\">\n  <span class=\"icon-warning\"></span>\n  <p class=\"message-container\">\n    <ng-transclude></ng-transclude>\n  </p>\n  <span ng-hide=\"$ctrl.disabledClose\" class=\"icon-cross\" ng-click=\"$ctrl.messageAlert = false\"></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/alertCard/alertCard.html
// module id = 902
// module chunks = 0